import { isString } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";

export function usePayPalAuthorization(
    authorizationHandler: (authCode: string, sharedId: string) => void,
) {
    const paypalWindowRef = useRef<Window | null>();
    const initializeConnection = useCallback(() => {
        paypalWindowRef.current = window.open("/api/paypal-auth");
        setHandlerActive(true);
    }, []);
    const [handlerActive, setHandlerActive] = useState(false);

    useEffect(() => {
        if (!handlerActive) {
            return;
        }

        const eventHandler = (event: MessageEvent) => {
            if (!isString(event.data)) {
                return;
            }
            try {
                const data = JSON.parse(event.data);

                if (!data.onboardedCompleteToken || !data.sharedId) {
                    return;
                }

                paypalWindowRef.current?.close();
                setHandlerActive(false);
                authorizationHandler(
                    data.onboardedCompleteToken,
                    data.sharedId,
                );
            } catch (error) {
                if (error instanceof SyntaxError) {
                    return;
                }
                throw error;
            }
        };

        window.addEventListener("message", eventHandler);

        return () => {
            window.removeEventListener("message", eventHandler);
        };
    }, [authorizationHandler, handlerActive]);

    return {
        initializeConnection,
    };
}
